(() => {
  const root = document.getElementById('ring-builder-app');
  if (!root || root.dataset.damasciInfiniteScroll === '1' || !window.IntersectionObserver) return;
  root.dataset.damasciInfiniteScroll = '1';

  let button = null;
  let pending = null;
  let attempted = '';
  let armed = false;
  let allowScroll = true;
  let intentUntil = 0;
  let quietUntil = 0;
  let previousY = window.scrollY;
  let frame = 0;
  let internalClick = false;
  let timer = 0;

  const signature = () => [...root.querySelectorAll('.pc-table-grid [id^="setting-detail-"]')]
    .map(card => card.id).join('|');
  const findButton = () => [...root.querySelectorAll('.pc-table-grid button')]
    .find(node => /^load more diamonds$/i.test(node.textContent.trim())) || null;
  const ready = node => node && node.isConnected && !node.disabled && node.getClientRects().length > 0;
  const release = () => {
    window.clearTimeout(timer);
    pending = null;
    armed = false;
  };
  const begin = current => {
    attempted = current;
    pending = { signature: current };
    armed = false;
    intentUntil = 0;
    window.clearTimeout(timer);
    timer = window.setTimeout(release, 30000);
  };

  const update = () => {
    frame = 0;
    if (!root.isConnected) return;
    const next = findButton();
    if (next !== button) {
      if (button) intersection.unobserve(button);
      button = next;
      if (button) intersection.observe(button);
    }
    const current = signature();
    if (pending) {
      if (current && current !== pending.signature) release();
      else return;
    }
    if (!armed || !current || current === attempted || !ready(button) ||
        Date.now() < quietUntil || document.visibilityState !== 'visible' ||
        document.activeElement === button) return;
    const rect = button.getBoundingClientRect();
    if (rect.top > window.innerHeight + 240) return;
    begin(current);
    internalClick = true;
    try { button.click(); } finally { internalClick = false; }
  };
  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };
  const intersection = new IntersectionObserver(schedule, { rootMargin: '0px 0px 240px 0px' });
  const changes = new MutationObserver(schedule);
  changes.observe(root, { childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['disabled', 'class', 'style'] });

  window.addEventListener('wheel', event => {
    if (event.deltaY > 0) {
      allowScroll = true;
      intentUntil = Date.now() + 1500;
      if (!pending && Date.now() >= quietUntil) armed = true;
      schedule();
    }
  }, { passive: true });
  window.addEventListener('touchmove', () => {
    allowScroll = true;
    intentUntil = Date.now() + 1500;
  }, { passive: true });
  window.addEventListener('keydown', event => {
    if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    if (['ArrowDown', 'PageDown', ' '].includes(event.key)) { allowScroll = true; intentUntil = Date.now() + 1500; }
    if (event.key === 'End') { armed = false; allowScroll = false; intentUntil = 0; }
  });
  window.addEventListener('pointerdown', () => { allowScroll = true; intentUntil = Date.now() + 1500; }, { passive: true });
  window.addEventListener('pointermove', event => {
    if (event.buttons === 1) intentUntil = Date.now() + 1500;
  }, { passive: true });
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > previousY + 1 && allowScroll && Date.now() < intentUntil && !pending && Date.now() >= quietUntil) armed = true;
    previousY = y;
    schedule();
  }, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  root.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const clicked = event.target.closest('button');
    if (clicked && clicked === findButton()) {
      if (internalClick) return;
      if (pending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      begin(signature());
      return;
    }
    release();
    intentUntil = 0;
    quietUntil = Date.now() + 1000;
  }, true);
  root.addEventListener('input', () => {
    release();
    intentUntil = 0;
    quietUntil = Date.now() + 1000;
  }, true);
  window.addEventListener('pagehide', () => {
    release();
    intentUntil = 0;
    allowScroll = true;
  });
  schedule();
})();
